var changeUrl={
  methods: {
    changeUrl(obj){
      let oldquery =this.$route.query;
      let newQuery={
        ...oldquery,
        ...obj
      }
      this.$router.replace({query:newQuery})
    },
  },
}
export default{
  changeUrl
}